import { Company } from './company';

export interface User {
  id: number;
  user_name: string;
  full_name?: string;

  first_name?: string;
  last_name?: string;

  email?: string;
  phone_number?: string;
  photo?: string;

  is_active: boolean;

  role_id: number;
  role?: UserRole;

  company_id?: number;
  company?: Company;
}

export interface UserRole {
  id: number;
  role_name: string;
  role_description: string;
  is_super_role?: boolean;
}

export enum Roles {
  Admin = 'admin', // admin
  Security = 'security', // รปภ
  Supervisor = 'supervisor', // ผู้คุมงาน
  Requester = 'requester' // ผู้ขอเข้าระบบ
}
